import { STAFF_PATH } from "./hosts";

// Which login this device uses ("door"), remembered so the installed app opens the right place.
const KEY = "buma_door", PATH_KEY = "buma_door_path";
export const DOORS = { staff: STAFF_PATH, teacher: STAFF_PATH, family: "/family/login", kids: "/join" };
const LOGIN_PAGES = /^(\/login|\/staff-login|\/family\/login|\/join)(\?|$)/;
const STAFF = ["center_admin", "super_admin", "role_manager", "finance_manager", "org_manager", "org_finance", "org_teacher_manager", "org_admin_officer"];

export const doorForRole = (role) => (role === "student" ? "kids" : role === "parent" ? "family" : role === "trainer" ? "teacher" : STAFF.includes(role) ? "staff" : null);
export function rememberDoor(user) {
  const door = doorForRole(user?.role);
  if (!door) return;
  try {
    localStorage.setItem(KEY, door);
    const here = window.location.pathname + window.location.search.replace(/[?&]source=pwa/, "");
    if (LOGIN_PAGES.test(here)) localStorage.setItem(PATH_KEY, here.replace(/[?&]next=[^&]*/, "")); else localStorage.removeItem(PATH_KEY);
  } catch { /* private mode */ }
}
export const savedDoor = () => { try { return localStorage.getItem(KEY); } catch { return null; } };
export function saveDoor(door) { try { localStorage.setItem(KEY, door); localStorage.removeItem(PATH_KEY); } catch { /* ignore */ } }
export function clearDoor() { try { localStorage.removeItem(KEY); localStorage.removeItem(PATH_KEY); } catch { /* ignore */ } }
export function doorPath() {
  const d = savedDoor();
  if (!d || !DOORS[d]) return null;
  try { return localStorage.getItem(PATH_KEY) || DOORS[d]; } catch { return DOORS[d]; }
}
// signed-in user → their own area
export const homeFor = (u) => (u.role === "parent" && u.org_id ? "/family" : u.role === "student" ? "/home" : u.role === "trainer" ? "/trainer" : STAFF.includes(u.role) ? "/backoffice" : "/projects");
export const isAppLaunch = () => { try { return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true || new URLSearchParams(window.location.search).get("source") === "pwa"; } catch { return false; } };
